import LocationPageTemplate from '../components/LocationPageTemplate';
export default function ColumbiaPage() { return <LocationPageTemplate locationSlug="columbia" />; }
